var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1279 89.402C14.0381 83.5804 17.3145 75.977 21.657 67.6257C21.6547 67.6303 21.6523 67.635 21.6499 67.6396C27.2424 71.298 33.5221 73.9858 40.264 75.4591C23.956 78.2734 16.7671 85.8304 13.845 91.2147C8.92117 100.287 10.423 94.5984 12.1279 89.402Z",
    fill: "#6160A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6499 67.6395C23.8478 63.412 26.319 58.9926 29.0246 54.5156C35.2741 58.8176 42.7393 61.4342 50.7877 61.723C49.9771 61.7119 49.1516 61.67 48.3116 61.5963C57.9475 64.5983 63.0393 62.6133 66.8161 61.141C67.2964 60.9538 67.7554 60.7748 68.1999 60.6155C59.6556 70.3254 54.0767 73.1796 40.7535 75.3766C40.5895 75.4036 40.4264 75.4311 40.2642 75.4591C33.5222 73.9858 27.2425 71.298 21.6499 67.6395Z",
    fill: "#90DF9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0134 54.534C42.4408 32.3105 61.6445 8.66176 81.861 0C84.0332 2.74621 86.6026 10.4573 84.9987 18.8333C82.2472 33.2021 70.8066 41.8294 57.242 41.488C59.4465 42.6486 67.862 45.8054 77.8061 41.2937C73.8262 53.7583 63.7543 62.5871 49.1424 61.6592C41.7176 61.095 34.8372 58.5464 29.0134 54.534Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.46c3d97102824c827e8fb7e5d6ffa2f1.svg";
export { ForwardRef as ReactComponent };